// extracted by mini-css-extract-plugin
export default {"resource":"LT","title":"MT","items":"NT","resource_item":"OT","text":"PT","button":"QT"};
    if(module.hot) {
      // 1711394579676
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  